<template>
  <div ref="dropdownRef" class="dropdown-container">
    <button :class="{ opened: isOpen }" class="dropdown-toggle" @click="toggleDropdown">
      <span class="dropdown-toggle-text">
        {{ dropdownLabel }}
        <span v-if="modelValue.length > 0">({{ modelValue.length }} valgt)</span>
      </span>

      <svg class="caret-right icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M6.71094 18L14.7109 10L6.71094 2L5.29427 3.41667L11.8776 10L5.29427 16.5833L6.71094 18Z" fill="currentColor"/>
      </svg>
    </button>

    <div :class="{ hidden: !isOpen }" class="dropdown-menu" role="listbox" tabindex="-1">
      <div class="inner">
        <label
          v-for="tag in tags"
          :key="tag"
          class="dropdown-item"
        >
          {{ tag }}
          <input
              type="checkbox"
              hidden
              :value="tag"
              :checked="modelValue.includes(tag)"
              @change="onTagChange(tag, $event)"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  modelValue: Array,
  tags: Array,
  dropdownLabel: String
})
const emit = defineEmits(['update:modelValue'])

const isOpen = ref(false)
const dropdownRef = ref(null)

function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function onTagChange(tagName, event) {
  const newTags = [...props.modelValue]
  const index = newTags.indexOf(tagName)

  if (event.target.checked && index === -1) {
    newTags.push(tagName)
  } else if (!event.target.checked && index !== -1) {
    newTags.splice(index, 1)
  }

  emit('update:modelValue', newTags)
}

function handleClickOutside(event) {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.dropdown-menu.hidden {
  display: none;
}
</style>
